import { FC } from 'react'
import Link from 'next/link'
import styled from 'styled-components'

const Header = styled.header`
  width: 228px;
  border: 1px #dfdfdf solid;
  border-bottom: none;
  background-color: #018cb3;
  color: #fff;
  padding: 14px 10px;
  font-size: 18px;
`

const AsideContent = styled.main`
  padding-bottom: 20px;
  border: 1px #dfdfdf solid;
  border-top: none;
`

const Item = styled.li`
  list-style: none;
  padding-top: 20px;
  padding-left: 10px;
  line-height: 1.4;

  a {
    color: #000;

    &:hover {
      color: #c30;
    }
  }
`

const Contact = styled.aside`
  margin-top: 24px;
`

const Aside: FC = () => {
  return (
    <div>
      <aside>
        <Header>走进我们</Header>
        <AsideContent>
          <Item>
            <Link href="/about">
              <a>书画院简介</a>
            </Link>
          </Item>
          <Item>
            <Link href="/artist">
              <a>书画名家</a>
            </Link>
          </Item>
          <Item>
            <Link href="/work">
              <a>书画欣赏</a>
            </Link>
          </Item>
          <Item>
            <Link href="/post/comment">
              <a>名家点评</a>
            </Link>
          </Item>
          <Item>
            <Link href="/post/course">
              <a>艺术讲堂</a>
            </Link>
          </Item>
        </AsideContent>
      </aside>

      <Contact>
        <Header>联系方式</Header>
        <AsideContent>
          <Item>电话: 010 - 80365711</Item>
          <Item>邮箱: zjdshx@126.com</Item>
          <Item>
            地址: 北京市房山区长阳大宁村
            <br />
            东329号
          </Item>
        </AsideContent>
      </Contact>
    </div>
  )
}

export default Aside
